module.exports = __webpack_public_path__ + "img/menu_close.9f54a8aa.svg";